import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  // namespaced: true,
  state: {
    users: [],
    user: {},
  },
  mutations: {
    users(state, users) {
      state.users = users;
    },
    user(state, user) {
      state.user = user;
    }
  },
  actions: {
    getUsers({ commit }, search) {
      return new Promise((resolve, reject) => {
        axios.get('/api/users?search=' + search)
          .then(res => {
            commit('users', res.data)
            resolve()
          })
          .catch(err => {
            reject(err)
            console.error(err);
        })
      })
    }
  }
}
